import DownloadReportMapping from "./DownloadReportMapping"
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import BasicCard from "../../../components/basics/cards/BasicCard"

export default function ReportMapping() {

    return (
        <BasicCard cardConfig={{ cardTitle: 'Report mapping administration', cardHeaderElement: 'h4' }}>
            <Tabs defaultActiveKey='download' id='node-admin-tabs' className='mb-3'>
                <Tab eventKey='download' title='Download report mapping'>
                    <DownloadReportMapping />
                </Tab>
            </Tabs>
        </BasicCard>
    )
}